






































import { Vue, Component, Prop } from 'vue-property-decorator';
import type {
  IField,
  IPricingTableCurrencySettings,
  IPricingTableSection,
  IPricingTableSummaryValues,
} from '@getaccept/editor-lib';
import {
  PricingTableHelper,
  getTotalDiscount,
  getTotalDiscountIsEmpty,
  getTotalTax,
  getTotalTaxIsEmpty,
  getTotalPriceValue,
} from '@getaccept/editor-lib';

@Component({
  data: () => ({
    PricingTableHelper,
    getTotalTaxIsEmpty,
    getTotalDiscountIsEmpty,
    getTotalPriceValue,
  }),
})
export default class PricingTablePriceSummary extends Vue {
  @Prop() summaryValues: IPricingTableSummaryValues;
  @Prop() currencySettings: IPricingTableCurrencySettings;
  @Prop() isPreCalculated: boolean;
  @Prop() sections: IPricingTableSection[];
  @Prop() fields: IField[];

  getTotalTaxValue(): string {
    if (getTotalTaxIsEmpty(this.summaryValues)) {
      return '';
    }
    return getTotalTax(
      this.summaryValues,
      this.currencySettings,
      this.isPreCalculated,
      this.sections,
      this.fields
    );
  }

  getTotalDiscountValue(): string {
    if (getTotalDiscountIsEmpty(this.summaryValues)) {
      return '';
    }
    return getTotalDiscount(
      this.summaryValues,
      this.currencySettings,
      this.isPreCalculated,
      this.sections,
      this.fields
    );
  }
}
